import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  padding: 2rem;
  padding-bottom: 0;
  gap: 0.75rem;
  flex-direction: column;
  background: #f3f4f6;

  .default-background {
    > div:nth-child(2) {
      background-color: #f6f6f6 !important;
    }
  }
`;
export const Actions = styled.div`
  display: flex;
  width: 100%;
  height: 4rem;
  justify-content: end;
  align-items: center;
  padding: 0 1rem;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
`;
export const Title = styled.div`
  position: relative;
  width: 100%;
  max-width: 700px;
  text-align: center;
  padding: 1rem;
  border-radius: 4px;
  font-size: 1.3rem;
  margin-top: 1.75rem;
  font-weight: bolder;
  background-color: #ffffff;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  border-left: 3px solid #1d86ff;
  > span {
    position: absolute;
    display: flex;
    width: 5rem;
    height: 5rem;
    top: -35px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    font-size: 1.5rem;
    color: #ffff;
    background-color: #1d86ff;
    box-shadow: rgb(0 0 0 / 20%) 0px 2px 1px -1px,
      rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px;
  }
  > div {
    margin-left: 5rem;
  }
`;
export const Content = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  padding: 0.75rem;
  gap: 0.2rem;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  overflow: hidden;
  > div:nth-child(1) {
    display: flex;
    gap: 0.5rem;
    justify-content: space-between;
    margin-bottom: 0.75rem;
    .uFN {
      border-radius: 4px;
      max-width: 450px;
      background: transparent;
      border: solid 1px #e8e8e8;
    }
    .uFS {
      max-width: 100px;
    }
    > button {
      outline: none;
      border: none;
      display: flex;
      width: 10rem;
      gap: 0.5rem;
      padding: 0.5rem;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      border-radius: 4px;
      background-color: #1d86ff;
      color: #ffffff;
      font-size: 14px;
      box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%),
        0 2px 4px -1px rgb(0 0 0 / 6%);
      &:hover {
        opacity: 0.9;
      }
    }
  }
`;
export const ListUsers = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding-bottom: 3.5rem;
  > div {
    display: flex;
    min-height: 2rem;
    width: 100%;
    background: #ecedef;
    > span {
      display: flex;
      padding-left: 10px;
      justify-content: left;
      align-items: center;
    }
    > span:nth-child(1) {
      min-width: 60%;
    }
    > span:nth-child(2) {
      position: relative;
      min-width: 40%;
      gap: 0.5rem;
      > span {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .accessLevelInfo {
          visibility: visible;
        }
      }
    }
  }
  > ul {
    display: flex;
    flex-direction: column;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgb(0, 0, 0, 0.2);
    }
  }
`;
export const AccessLevelInfo = styled.ul`
  position: absolute;
  display: flex;
  max-width: 340px;
  min-width: 320px;
  max-height: 20rem;
  top: 2.5rem;
  left: -18rem;
  gap: 0.75rem;
  padding: 0.75rem;
  border-radius: 6px;
  flex-direction: column;
  background-color: #ffffff;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  visibility: hidden;
  border: solid 1px #ecedef;
  overflow: auto;
  cursor: default;
  > li {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f6f6f6;
    padding: 0.3rem;
    border-radius: 6px;
    > span {
      display: flex;
      min-width: 3rem;
      height: 100%;
      padding: 0.3rem;
      color: #ffffff;
      font-size: 12px;
      font-weight: bolder;
      text-align: center;
      justify-content: center;
      border-radius: 4px;
      background-color: #1d86ff;
    }
    > div {
      width: calc(100% - 3.1rem);
      margin-left: 10px;
      font-size: 12px;
      font-weight: 500;
      color: #6c757d;
    }
  }
`;
export const AccessLevelPermissions = styled.ul`
  position: absolute;
  display: flex;
  flex-direction: column;
  max-width: 400px;
  min-width: 380px;
  max-height: 20rem;
  top: 2.5rem;
  left: -16rem;
  gap: 0.75rem;
  padding: 2rem 0.75rem 0.75rem 0.75rem;
  border-radius: 6px;
  background-color: #ffffff;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  visibility: hidden;
  border: solid 1px #ecedef;
  overflow: auto;
  cursor: default;
  z-index: 100;

  &.accessLevelInfo {
    visibility: visible;
  }

  .clear-btn {
    position: absolute;
    top: 6px;
    right: 1rem;
    background: transparent;
    border: none;
    color: #6c757d;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    transition: 0.2s;

    &:hover {
      color: #1d86ff;
      transform: scale(1.1);
    }
  }

  > li {
    display: flex;
    align-items: center;
    background-color: #f6f6f6;
    padding: 0.3rem;
    border-radius: 6px;
    gap: 0.5rem;

    input[type="checkbox"] {
      accent-color: #1d86ff;
      width: 16px;
      height: 16px;
      cursor: pointer;
    }

    > span {
      display: flex;
      min-width: 3rem;
      height: 100%;
      padding: 0.3rem;
      color: #ffffff;
      font-size: 12px;
      font-weight: bolder;
      justify-content: center;
      border-radius: 4px;
      background-color: #1d86ff;
    }

    > div {
      width: calc(100% - 3.1rem);
      font-size: 12px;
      font-weight: 500;
      color: #6c757d;
    }
  }
`;
